import { QuestionBaseComponent } from 'src/app/components/question-base/question-base.component';
import { Component, Input, OnInit } from '@angular/core';
import { NavigationExtras, Router, ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-transitions',
  templateUrl: './transitions.component.html',
  styleUrls: ['./transitions.component.scss'],
})
export class TransitionsComponent implements OnInit {
  nItem: any;
  gifBack = '';
  listBacks = {
    13: '/assets/img/fondos-animados/gif1.gif',
    25: '/assets/img/fondos-animados/gif2.gif',
    35: '/assets/img/fondos-animados/gif3.gif',
  };
  constructor(
    private router: Router,
    private activedRoute: ActivatedRoute,
    private question: QuestionBaseComponent
  ) {
    this.activedRoute.queryParams.subscribe((params) => {
      if(params.nItem){
        this.setBackground(params.nItem);
        this.nItem = params.nItem
      }else{
        let currentState = this.router.getCurrentNavigation().extras;
        if ('state' in currentState) {
          this.nItem = this.router.getCurrentNavigation().extras.state.nItem;
          this.setBackground(this.nItem);
        } else {
          this.nItem = sessionStorage.getItem('numItem');
          this.setBackground(this.nItem);
        }
      }
    });
  }

  ngOnInit() {}

  setBackground(item) {
    this.gifBack = this.listBacks[item];
  }

  continue() {
    this.router.navigate(['test/item', this.nItem]);
  }

  results() {
    this.question.getResults();
  }
}
